import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useRef } from 'react';
import { injectTSDI } from 'ml-webclient-common/src/tsdi';
import { App } from '../../app';
import { Layout } from '../../components/layout';
import { FastFinanceLinkStore } from '../../store';
import { I18nStore } from '../i18n';
import { decodeIdentityParams, hasRedirectParams, isValidFflSearchParams, parseDataParam, parseDebtClaimIds, parseFlowParam, parseStepParam } from '../search-params';
export const Route = createFileRoute('/ffl/$data')({
    component: () => _jsx(FflPage, {})
});
const FflPage = observer(function FflPage() {
    const { data } = Route.useParams();
    const params = useMemo(() => {
        const { base64, extras } = parseDataParam(data);
        const identity = decodeIdentityParams(base64);
        const search = new URLSearchParams(window.location.search);
        for (const [key, value] of extras) {
            if (!search.has(key)) {
                search.set(key, value);
            }
        }
        return {
            ...identity,
            flow: parseFlowParam(search.get('flow')),
            debtClaimIds: parseDebtClaimIds(search.get('debtClaims')),
            activeFlow: parseFlowParam(search.get('activeFlow')),
            activeStep: parseStepParam(search.get('activeStep')),
            ust: search.get('ust') ?? undefined,
            fpRegion: search.get('fpRegion') ?? undefined
        };
    }, [data]);
    const isRedirect = useMemo(() => hasRedirectParams(), []);
    const initializedRef = useRef(false);
    useEffect(() => {
        if (isValidFflSearchParams(params) && !initializedRef.current) {
            initializedRef.current = true;
            const store = injectTSDI(FastFinanceLinkStore);
            store.initWithParams(params, isRedirect);
        }
    }, [params, isRedirect]);
    if (!isValidFflSearchParams(params)) {
        const i18n = injectTSDI(I18nStore);
        if (!i18n.isReady) {
            return _jsx(Layout, { children: _jsx("div", { style: {
                        padding: '2rem',
                        textAlign: 'center'
                    } }) });
        }
        return _jsx(Layout, { children: _jsx("div", { style: {
                    padding: '2rem',
                    textAlign: 'center'
                }, children: _jsx("p", { children: i18n.__('ffl.error.generic') }) }) });
    }
    return _jsx(Layout, { children: _jsx(App, {}) });
});
if (import.meta.hot) {
    import.meta.hot.accept(newModule => {
        if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
            newModule.Route.clone(Route);
        }
    });
}
